// extracted by mini-css-extract-plugin
module.exports = {"popupAlert":"style-module--popupAlert--vvydy","alertTitle":"style-module--alertTitle--3phDo"};